/**
 * Renders a whole-dollar amount with an explicit currency code
 * ("USD 597") rather than a bare "$597" that never states which
 * currency it is — every price on the site is USD, but nothing said
 * so. Shared so every price surface (pricing, the onboarding plan
 * picker, the upgrade modal, and the billing page) renders the same
 * way instead of each carrying its own `Intl` call.
 */
export function formatUsd(amount: number): string {
  return amount.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    currencyDisplay: "code",
    maximumFractionDigits: 0,
  });
}
